import { searchContent, getContent } from '@plone/volto/actions';
import { flattenToAppURL } from '@plone/volto/helpers';

// ---------------------------------------------------------------------------
// Constants
// ---------------------------------------------------------------------------

const NEWS_TYPES = ['news_item_ess'];

// ---------------------------------------------------------------------------
// Shared fetch functions – used by both SSR asyncPropsExtender and CSR hooks
// ---------------------------------------------------------------------------

export const fetchHomeContent = (dispatch) =>
  dispatch(getContent('/home', null, 'homeContent'));


export const fetchPartners = (dispatch) =>
  dispatch(getContent('/home-logos', null, 'homePartners'));


export const fetchTeams = (dispatch) =>
  dispatch(
    searchContent(
      '/about-us',
      {
        portal_type: 'service_showcase',
        sort_on: 'getObjPositionInParent',
        sort_order: 'ascending',
        review_state: 'published',
        metadata_fields: ['image_scales', 'short_description'],
        b_size: 4,
      },
      'homeOurTeams',
    ),
  );

export const fetchNews = (dispatch) =>
  dispatch(
    searchContent(
      '/',
      {
        portal_type: NEWS_TYPES,
        media_news: false,
        sort_on: 'effective',
        sort_order: 'descending',
        review_state: 'published',
        b_size: 3,
      },
      'homeLatestNews',
    ),
  );

// ---------------------------------------------------------------------------
// Highlighted work – fetch by UIDs and sort to match relation field order
// ---------------------------------------------------------------------------

export const fetchHighlightedWork = (dispatch, highlightedWork) => {
  if (!highlightedWork || highlightedWork.length === 0) return null;

  const uids = highlightedWork
    .map((rel) => rel.UID || rel.token || '')
    .filter(Boolean);

  if (uids.length === 0) return null;

  return dispatch(
    searchContent(
      '/',
      {
        UID: uids,
        review_state: 'published',
        metadata_fields: ['image_scales', 'description', 'short_description'],
        b_size: 4,
      },
      'homeHighlightedWork',
    ),
  );
};

export const sortHighlightedWork = (items, highlightedWork) => {
  if (!items?.length || !highlightedWork?.length) return [];

  const orderMap = {};
  highlightedWork.forEach((rel, idx) => {
    const id = rel['@id'] || rel.intId || '';
    if (id) orderMap[flattenToAppURL(id)] = idx;
    const uid = rel.UID || rel.token || '';
    if (uid) orderMap[uid] = idx;
  });

  return [...items]
    .sort((a, b) => {
      const aKey = flattenToAppURL(a['@id']) || a.UID;
      const bKey = flattenToAppURL(b['@id']) || b.UID;
      const aIdx = orderMap[aKey] ?? 999;
      const bIdx = orderMap[bKey] ?? 999;
      return aIdx - bIdx;
    })
    .slice(0, 4);
};
